import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { signout, signoutImpersonatedUser } from '../actions';

class Signout extends Component {
  componentDidMount() {
    if (this.props.isUserImpersonated) {
      return this.props.signoutImpersonatedUser();
    }
    return this.props.signout();
  }

  render() {
    return null;
  }

}

Signout.propTypes = {
  signout: PropTypes.func.isRequired,
  signoutImpersonatedUser: PropTypes.func.isRequired,
  isUserImpersonated: PropTypes.bool,
};

const mapStateToProps = state => ({
  isUserImpersonated: state.auth.isUserImpersonated,
});

const mapDispatchToProps = {
  signout,
  signoutImpersonatedUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Signout);
